import _isNil from 'lodash/isNil';
import { useStoreState } from '../../models/hooks';

export const useUserIsAuthenticated = (): boolean => {
  const currentUser = useStoreState((state) => state.app.user);
  return !_isNil(currentUser);
};
